import statuses from './index.js';

/* istanbul ignore next line */
const SET_SALES_ORDER_STATUSES = (state, salesOrderStatuses) => {
  state.salesOrderStatuses = salesOrderStatuses;
  state.salesOrderStatusesOutDated=false;
};

/* istanbul ignore next line */
const SET_PURCHASE_ORDER_STATUSES = (state, purchaseOrderStatuses) => {
  state.purchaseOrderStatuses = purchaseOrderStatuses;
  state.purchaseOrderStatusesOutDated=false;
};

/* istanbul ignore next line */
const SET_INVOICE_STATUSES = (state, invoiceStatuses) => {
  state.invoiceStatuses = invoiceStatuses;
  state.invoiceStatusesOutDated=false;
};

const SET_INVOICE_NOTICE_STATUSES = (state, invoiceNoticeStatuses) => {
  state.invoiceNoticeStatuses = invoiceNoticeStatuses;
  state.invoiceNoticeStatusesOutDated=false;
};


const SET_PACKAGE_STATUSES = (state, packageStatuses) =>{
  state.packageStatuses = packageStatuses;
  state.packageStatusesOutDated=false;
}

const SET_CREDIT_NOTE_STATUSES = (state, creditNoteStatuses) =>{
  state.creditNoteStatuses = creditNoteStatuses;
  state.creditNoteStatusesOutDated = false;
}

/* istanbul ignore next line */
const RESET_STATE = state => {
  Object.assign(state, statuses.getDefaultState());
};

export default {
  SET_SALES_ORDER_STATUSES,
  SET_PURCHASE_ORDER_STATUSES,
  SET_INVOICE_STATUSES,
  SET_PACKAGE_STATUSES,
  SET_CREDIT_NOTE_STATUSES,
  RESET_STATE,
  SET_INVOICE_NOTICE_STATUSES
};
